import { createTheme }  from '@material-ui/core/styles';
// import { esES as coreEsES} from '@mui/material/locale';

//Primary palette: the most widely used colors across all screens and components.
var custom_bhp_primary = {
  50: '#FEF3E1',
  100: '#FCE1B3',
  200: '#FBCE82',
  300: '#F9BA50',
  400: '#F9AB2B',
  500: '#F89D0C',
  600: '#F49108',
  700: '#EE8105',
  800: '#E87202',
  900: '#DF5900'
};

var custom_bhp_secondary = {
  50: '#FBFBFB',
  100: '#F6F6F6',
  200: '#F1F1F1',
  300: '#E4E4E4',
  400: '#C2C2C2',
  500: '#A3A3A3',
  600: '#7A7A7A',
  700: '#666666',
  800: '#464646',
  900: '#252525'
};

const themelight = createTheme({

  palette: {
    type: "light",
    primary: { 
      main : custom_bhp_primary[900],
     },
     secondary: { 
      main : custom_bhp_secondary[800]
     },
  },  
},

);

export default themelight;